import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { LoadingScreen } from 'components';
import { session, useSession } from 'session';

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const status = useSession((state) => state.status);

  useEffect(() => {
    session.resolveStatus();
  }, []);

  if (status === null) {
    return <LoadingScreen />;
  }

  if (status === 'anonymous') {
    return <Navigate to="/" replace />;
  }

  return children;
}
